import { format } from "date-fns";

export const getSentenceFromCamelCase = (message) => {
  const pattern = /[A-Za-z]/g;
  const messages = message.match(pattern);
  let errorMessage = "";
  for (let i = 0; i < messages.length; i++) {
    errorMessage +=
      messages[i] === messages[i].toUpperCase()
        ? ` ${messages[i].toLowerCase()}`
        : messages[i];
  }
  return errorMessage.trim();
};

export const getRegExp = (type) => {
  let regex = null;
  switch (type) {
    case "email":
      regex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g;
      break;
    case "number":
      regex = /^[0-9]*$/;
      break;
    case "password":
      regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
      break;
    default:
      break;
  }
  return regex;
};

export const checkValidation = (errors, data) => {
  const finalErrors = {};
  Object.keys(data).forEach((key) => {
    if (!data[key]) {
      finalErrors[key] = `Please enter ${getSentenceFromCamelCase(key)} `;
    }
  });
  Object.keys(errors).forEach((key) => {
    if (errors[key] !== "") {
      finalErrors[key] = errors[key];
    }
  });
  return finalErrors;
};

export const getStringInLowerCaseWithOutSpace = (string) =>
  string.toLowerCase().replace(/\s/g, "");

export const getRandomId = () =>
  new Date().getTime().toString() + Math.floor(Math.random() * 1000000);

export const getItemFromStorage = (key) => {
  const item = window.localStorage.getItem(key);
  return item ? JSON.parse(item) : null;
};

export const setItemInStorage = (name, data) => {
  window.localStorage.setItem(name, JSON.stringify(data));
};

export function formatDate(date) {
  var d = new Date(date);
  var month = "" + (d.getMonth() + 1);
  var day = "" + d.getDate();
  var year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return year + "-" + month + "-" + day;
}

export function dateConversion(date) {
  if (date === undefined || date === null) {
    return;
  }
  var Date = date;
  var datearray = Date.split("-");

  var newdate = datearray[2] + "-" + datearray[1] + "-" + datearray[0];
  return newdate;
}
export function getCurrentURL() {
  return window.location.href;
}

export function removeSlashfromDate(date2) {
  const date = date2.replaceAll("/", "-");
  let result = date.slice(0, 11);
  return result;
}

export function DiffBtwTwoDates(dateString1, dateString2) {
  // Parse date strings into Date objects
  var dateParts1 = dateString1.split("-");
  var dateParts2 = dateString2.split("-");
  var date1 = new Date(dateParts1[2], dateParts1[1] - 1, dateParts1[0]);
  var date2 = new Date(dateParts2[2], dateParts2[1] - 1, dateParts2[0]);

  // Calculate the difference in months
  var monthsDiff = (date1.getFullYear() - date2.getFullYear()) * 12;
  return `${monthsDiff} Months`;
}
export function toBase64(file) {
  let base64 = "";
  if (file) {
    var filereader = new FileReader();
    filereader.readAsDataURL(file);
    filereader.onload = function (evt) {
      base64 = evt.target.result;
    };
  }
  return base64;
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let encoded = reader.result.toString().replace(/^data:(.*,)?/, "");
      if (encoded.length % 4 > 0) {
        encoded += "=".repeat(4 - (encoded.length % 4));
      }
      return resolve(encoded);
    };
    reader.onerror = (error) => {
      return reject(error);
    };
  });
  // var file = element.files[0];
  // var reader2 = new FileReader();
  // reader2.onloadend = function () {
  // };
  // reader2.readAsDataURL(file);
}
export function validateDateRangeUPTO2Year(startDateString) {
  var d1 = new Date(); //"now"
  var d2 = new Date(startDateString); // some date
  var diff = Math.abs(d1 - d2); // difference in milliseconds
  var twoYearsInMilliseconds = 2 * 365 * 24 * 60 * 60 * 1000; // Two years in milliseconds
  if (diff <= twoYearsInMilliseconds) {
    return true; // Valid date range
  } else {
    return false; // Date range exceeds 2 years
  }
}

export function validate3monthDateRange(startDateString, endDateString) {
  var startDate = new Date(startDateString);
  var endDate = new Date(endDateString);

  var threeMonthsInMilliseconds = 7889400000; // 3 months in milliseconds

  if (endDate - startDate <= threeMonthsInMilliseconds) {
    return true; // Valid date range
  } else {
    return false; // Date range exceeds 2 years
  }
}
export function YYYYMMDD(date) {
  const today = new Date(date);
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedToday = yyyy + "-" + mm + "-" + dd;
  return formattedToday;
}

export function reformatDateString(s) {
  const a = s.split(" ")[0];
  const b = s.split(" ")[1];
  var d = a.split(/\D/);
  return d.reverse().join("-") + " " + b;
}

export function YYYYDDMMHHSS(dateString) {
  const YYYYDDMM = reformatDateString(dateString);
  const dt = new Date(YYYYDDMM);
  const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);

  const dateORG =
    dt.getFullYear() +
    "-" +
    padL(dt.getMonth() + 1) +
    "-" +
    padL(dt.getDate()) +
    " " +
    padL(dt.getHours()) +
    ":" +
    padL(dt.getMinutes()) +
    ":" +
    padL(dt.getSeconds());
  return dateORG;
}

export const queryMultipleBalanceApiCallHelper = async (
  json = "",
  Supplementary = false,
  InterShare = false,
  InternetAllshare = false
) => {
  let billingAccountNum = "";
  let params = "";
  const DataFrom = Supplementary ? json.services : json[0].account;
  if (InternetAllshare === true) {
    const billingAccountNumber = DataFrom[0]?.externalReference.find(ref => ref.externalReferenceType === "cbsAccountId")?.value;
    const smeGroupIdData = DataFrom[0]?.characteristic.find((char) => char.name === 'smeGroupId')?.value;
    const serialNumber = (DataFrom[0]?.serviceIdentifier)? DataFrom[0]?.serviceIdentifier: DataFrom[0].relatedAccount[0]?.serviceIdentifier;
    params = JSON.stringify({
      listOfCmuRequestBillingProfileIo: {
        comInvoiceProfile: [
          {
            billingAccountNumber: billingAccountNumber, //301019956 //cust[0].accountno 301045068--two month and one month
            endTime: "",
            groupId: smeGroupIdData, //563525204 //ApiData?.smeGroupId //648691267--two month and one month
            operateType: "DataDetails",
            serialNumber: serialNumber,
            startTime: "",
          },
        ],
      },
    });
  } else {
    billingAccountNum = DataFrom?.map((item) => {
      return {
        AccountNo: item.externalReference.find(ref => ref.externalReferenceType === "cbsAccountId")?.value,
        smeGroupId: item.characteristic.find((char) => char.name === 'smeGroupId')?.value,
        serialNumber: (DataFrom[0]?.serviceIdentifier)? DataFrom[0]?.serviceIdentifier: DataFrom[0].relatedAccount[0]?.serviceIdentifier,
      };
    });
    const list =
      billingAccountNum &&
      billingAccountNum?.map((item) => {
        return {
          billingAccountNumber: item?.AccountNo,
          endTime: null,
          groupId: InterShare === true ? item?.smeGroupId : "",
          operateType: InterShare === true ? "DataDetails" : "",
          serialNumber: item?.serialNumber,
          startTime: "",
        };
      });

    params = JSON.stringify({
      listOfCmuRequestBillingProfileIo: {
        comInvoiceProfile: list,
      },
    });
  }

  let response = await fetch("/bizcareui/api/queryMultipleBalance", {
    method: "POST",
    headers: {
      Accept: "application/json",
    },
    body: params,
  }).then((response) => response.json());
  const queryData = "";
  if (InterShare === true) {
    queryData = response;
  } else if (InternetAllshare === true) {
    queryData = response;
  } else {
    queryData = response?.listOfCmuBalanceSummaryResponseIo
      ?.cmuBalanceSummaryVbc
      ? response?.listOfCmuBalanceSummaryResponseIo?.cmuBalanceSummaryVbc?.map(
          (item, key) => {
            return {
              serviceID: item.serviceID,
              RM: item.balance,
              latestBillDueDate: item.latestBillDueDate,
              billCycle: item.billCycle,
            };
          }
        )
      : "";
  }
  return queryData;
};

import React, { useEffect, useRef } from "react";

export const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};
export function DDMMYYYYHHMMSS(date) {
  const today = new Date(date);
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();
  let HH = today.getHours();
  let MM = today.getMinutes();
  let SS = today.getSeconds();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  if (HH < 10) HH = "0" + HH;
  if (MM < 10) MM = "0" + MM;
  // if (SS < 10) SS = '0' + SS;

  let formattedToday =
    dd +
    "-" +
    mm +
    "-" +
    yyyy +
    " " +
    `${HH === 0 ? "00" : HH + ":"}` +
    `${MM === 0 ? "00" : MM}`;
  // +
  // `${SS === 0 ? '' : SS}`;
  return formattedToday;
}
export const convertDate = (date) => {
  return format(
    new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kuala_Lumpur" })),
    "dd-MM-yyyy"
  );
};

export const convertDateWithTime = (date) => {
  return format(
    new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kuala_Lumpur" })),
    "dd-MM-yyyy kk:mm"
  );
};

export const convertDateTimeWithSecond = (date) => {
  return format(
    new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kuala_Lumpur" })),
    "dd-MM-yyyy kk:mm:ss"
  );
};

export const convertStringToDate = (date) => {
  const dateComponents = date.split(" ");

  const monthMap = {
    Jan: "January",
    Feb: "February",
    Mar: "March",
    Apr: "April",
    May: "May",
    Jun: "June",
    Jul: "July",
    Aug: "August",
    Sep: "September",
    Oct: "October",
    Nov: "November",
    Dec: "December",
  };

  const formattedDateStr = `${monthMap[dateComponents[1]]} ${
    dateComponents[2]
  }, ${dateComponents[5]} ${dateComponents[3]}`;
  return format(
    new Date(
      formattedDateStr.toLocaleString("en-US", {
        timeZone: "Asia/Kuala_Lumpur",
      })
    ),
    "dd-MM-yyyy kk:mm"
  );
};

export const crypt = (salt, text) => {
  const textToChars = (text) => text?.split("")?.map((c) => c?.charCodeAt(0));
  const byteHex = (n) => ("0" + Number(n)?.toString(16))?.substr(-2);
  const applySaltToChar = (code) =>
    textToChars(salt)?.reduce((a, b) => a ^ b, code);

  return text
    ?.split("")
    ?.map(textToChars)
    ?.map(applySaltToChar)
    ?.map(byteHex)
    ?.join("");
};

export const decrypt = (salt, encoded) => {
  const textToChars = (text) => text?.split("")?.map((c) => c?.charCodeAt(0));
  const applySaltToChar = (code) =>
    textToChars(salt)?.reduce((a, b) => a ^ b, code);
  return encoded
    ?.match(/.{1,2}/g)
    ?.map((hex) => parseInt(hex, 16))
    ?.map(applySaltToChar)
    ?.map((charCode) => String?.fromCharCode(charCode))
    ?.join("");
};

export function cleanStringify(object) {
  if (object && typeof object === "object") {
    object = copyWithoutCircularReferences([object], object);
  }
  return JSON.stringify(object);

  function copyWithoutCircularReferences(references, object) {
    var cleanObject = {};
    Object.keys(object).forEach(function (key) {
      var value = object[key];
      if (value && typeof value === "object") {
        if (references.indexOf(value) < 0) {
          references.push(value);
          cleanObject[key] = copyWithoutCircularReferences(references, value);
          references.pop();
        } else {
          cleanObject[key] = "###_Circular_###";
        }
      } else if (typeof value !== "function") {
        cleanObject[key] = value;
      }
    });
    return cleanObject;
  }
}

export function ValidURL(str) {
  var regex =
    /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
  if (!regex.test(str)) {
    return false;
  } else {
    return true;
  }
}
export function resolveReferences(json) {
  if (typeof json === "string") json = JSON.parse(json);

  var byid = {}, // all objects by id
    refs = []; // references to objects that could not be resolved
  json = (function recurse(obj, prop, parent) {
    if (typeof obj !== "object" || !obj)
      // a primitive value
      return obj;
    if (Object.prototype.toString.call(obj) === "[object Array]") {
      for (var i = 0; i < obj.length; i++)
        // check also if the array element is not a primitive value
        if (typeof obj[i] !== "object" || !obj[i])
          // a primitive value
          continue;
        else if ("$ref" in obj[i]) obj[i] = recurse(obj[i], i, obj);
        else obj[i] = recurse(obj[i], prop, obj);
      return obj;
    }
    if ("$ref" in obj) {
      // a reference
      var ref = obj.$ref;
      if (ref in byid) return byid[ref];
      // else we have to make it lazy:
      refs.push([parent, prop, ref]);
      return;
    } else if ("$id" in obj) {
      var id = obj.$id;
      delete obj.$id;
      if ("$values" in obj)
        // an array
        obj = obj.$values.map(recurse);
      // a plain object
      else for (var prop in obj) obj[prop] = recurse(obj[prop], prop, obj);
      byid[id] = obj;
    }
    return obj;
  })(json); // run it!

  for (var i = 0; i < refs.length; i++) {
    // resolve previously unknown references
    var ref = refs[i];
    ref[0][ref[1]] = byid[ref[2]];
    // Notice that this throws if you put in a reference at top-level
  }
  return json;
}
export function generateUniqueId(channelCode) {
  const date = new Date();
  const yy = date.getFullYear().toString().slice(-2); // Last two digits of the year
  const mm = String(date.getMonth() + 1).padStart(2, "0"); // Month (01-12)
  const dd = String(date.getDate()).padStart(2, "0"); // Day (01-31)
  const dateFormat = `${yy}${mm}${dd}`;

  // Generate a random alphanumeric string of length 11
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let randomString = "";
  for (let i = 0; i < 11; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    randomString += chars[randomIndex];
  }

  // Combine the parts and ensure the length is at most 20 characters
  const uniqueId = `${channelCode}${dateFormat}${randomString}`.slice(0, 20);

  return uniqueId;
}
